import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const removeFloatingWatermarks = () => {
  const candidates = document.querySelectorAll("a, div, span");
  candidates.forEach((node) => {
    const text = (node.textContent || "").trim().toLowerCase();
    if (!text.includes("made with")) {
      return;
    }

    const style = window.getComputedStyle(node);
    const isFixed = style.position === "fixed";
    const bottom = Number.parseInt(style.bottom || "999", 10);
    const right = Number.parseInt(style.right || "999", 10);
    if (isFixed && bottom <= 32 && right <= 32) {
      node.remove();
    }
  });
};

removeFloatingWatermarks();
const watermarkObserver = new MutationObserver(removeFloatingWatermarks);
watermarkObserver.observe(document.documentElement, { childList: true, subtree: true });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
